import React, {useState} from 'react';
import {connect} from "react-redux";
import {
  MEASURE_UNITS,
  SIDEBAR_NAVIGATION_BUTTONS,
  SQFT_BACKSPLASH_TYPES,
  SQFT_BACKSPLASH_TYPES_METRIC,
  SQFT_WALL_TYPES
} from "../../../../../constants";
import SqftNavBacksplashesFeature from "./SqftNavBacksplashesFeature";
import config from "../../../../canvas/store/sqftConfig";
import SqftNavBacksplashesCustomButton from "./toolBacksplash/SqftNavBacksplashesCustomButton";
import SqftNavBacksplashesFreeDrawButton from "./toolBacksplash/SqftNavBacksplashesFreeDrawButton";

const SqftNavBacksplashes = (props) => {
  // other popups, modals and so on
  const {menuOpened} = props;
  const [selectedBacksplash, setSelectedBacksplash] = useState(0);
  const expanded = menuOpened === SIDEBAR_NAVIGATION_BUTTONS.backsplash;
  // other popups, modals and so on
  const backsplashOptions = config.measureUnit === MEASURE_UNITS.Imperial
    ? SQFT_BACKSPLASH_TYPES.concat(SQFT_WALL_TYPES)
    : SQFT_BACKSPLASH_TYPES_METRIC.concat(SQFT_WALL_TYPES)

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")} data-content="backsplash" id="backsplash-overlay">
      <div className="content-inner">
        <div className="lightbox-title-block">
          <span className="h7" data-text="sqft.navigation.backsplash.title">Select Backsplash</span>
          <p data-text="sqft.navigation.backsplash.description">Select a Backsplash and then click or touch the edges of
            the shape you want to have that backsplash.</p>
        </div>
        <div className="lightbox-button-block">
          <div className="lightbox-cancel-button" data-text="sqft.navigation.overlay.closeButton">Close</div>
        </div>
        <ul className="lightbox-options-wrapper">
          {backsplashOptions.map((navItem, index) =>
            <SqftNavBacksplashesFeature
              key={index}
              featureName={navItem}
              selectedBacksplash={selectedBacksplash}
              setSelectedBacksplash={setSelectedBacksplash}/>
            )
          }
          {
            <SqftNavBacksplashesCustomButton selectedBacksplash={selectedBacksplash}
                                             setSelectedBacksplash={setSelectedBacksplash}/>
          }
          {
            <SqftNavBacksplashesFreeDrawButton selectedBacksplash={selectedBacksplash}
                                               setSelectedBacksplash={setSelectedBacksplash}/>
          }
        </ul>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  return {
    menuOpened
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SqftNavBacksplashes);
